export default __webpack_public_path__ + "cf26d94f524e68f9bbc900559df17dea.png";